<template>
  <div class="img-and-content-container">
    <div class="img-and-content-inner">
      <div class="img-box">
        <img :src="imgSrc">
      </div>
      <div class="text-box">
        <h2 class="title">{{ $dt(eleConfig, 'title') }}</h2>
        <div class="content">{{ $dt(eleConfig, 'content') }}</div>
      </div>
      <div class="number-box">
        <div class="number-item num-1">
          <div class="number">80%</div>
          <div class="text">{{ $t('特殊F80') }}</div>
        </div>
        <div class="number-item num-2">
          <div class="number">90%</div>
          <div class="text">{{ $t('特殊F90') }}</div>
        </div>
        <div class="number-item num-3">
          <div class="number">100+</div>
          <div class="text">{{ $t('特殊F100') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialF",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-color: white;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    gap: 80px;
    position: relative;

    .img-box {
      flex: 1;

      img {
        width: 100%;
        height: auto;
      }
    }

    .text-box {
      flex: 1;
      align-self: flex-start;
      margin-top: 250px;

      .title {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 16px;
        line-height: 45px;
        color: #003C82;
      }

      .content {
        font-size: 18px;
        white-space: pre-wrap;
        line-height: 25px;
        color: #333333;
      }
    }

    .number-box {
      position: absolute;
      z-index: 1;
      right: 15px;
      top: 46px;
      display: flex;
      gap: 24px;

      .number-item {
        height: 150px;
        width: 230px;
        padding: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        color: white;
      }

      .number {
        font-weight: bold;
        font-size: 68px;
        line-height: 79px;
        text-align: center;
      }

      .text {
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
      }

      .num-1 {
        background-color: #d83479;
      }

      .num-2 {
        background-color: #6d7e9a;
      }

      .num-3 {
        background-color: #013d82;
      }
    }
  }
}
</style>
